import { render, staticRenderFns } from "./Hots.vue?vue&type=template&id=25787b42&scoped=true&"
import script from "./Hots.vue?vue&type=script&lang=js&"
export * from "./Hots.vue?vue&type=script&lang=js&"
import style0 from "./Hots.vue?vue&type=style&index=0&id=25787b42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25787b42",
  null
  
)

export default component.exports